import { getActiveEntity } from '@core/core/helpers'
import { selectActiveEntity, selectActiveProject, useAppSelector } from '@core/core/store'
import type { MicrofrontendProps } from '@core/core/types'
import { useTabsContext } from '@core/hooks'
import type { FC } from 'react'
import { lazy } from 'react'

import { TabWrapper } from '../TabWrapper'

const TableFront = lazy(() => import('@utils/Table'))

export const TableMF: FC<MicrofrontendProps> = props => {
  const entities = useTabsContext(props.tabId)
  const { id: projectId } = useAppSelector(selectActiveProject)
  const selectedTreeObject = useAppSelector(selectActiveEntity)
  const activeEntity = getActiveEntity(selectedTreeObject)
  const allProps = {
    ...props,
    entities,
    activeEntity,
    projectId,
  }

  return (
    <TabWrapper>
      <TableFront {...allProps} />
    </TabWrapper>
  )
}
